import get from 'lodash/get';
import isArray from 'lodash/isArray';
import map from 'lodash/map';

import {
  showNotification,
  showUpgradeModal,
  UPGRADE_MODALS,
} from 'app/toasts/slice';
import * as urls from 'app/urls';
import {gt} from 'app/utils/i18n';

const errorsUpgradeModalMap = {
  ACCOUNT_MANAGER_LIMIT_REACHED: UPGRADE_MODALS.MANAGER_LIMIT,
  SUDO_REQUIRED: UPGRADE_MODALS.SUDO_REQUIRED,
};

const Generic4XXErrorHandler = (error, dispatch) => {
  dispatch(
    showNotification(
      gt('ERROR %(number)s. Please contact support.', {
        number: error.response != null ? error.response.status : 0,
      }),
      'error'
    )
  );
};

const Generic5XXErrorHandler = (error, dispatch) => {
  dispatch(
    showNotification(
      gt(
        'Error encountered while processing the request. Please contact support.'
      ),
      'error'
    )
  );
  // Show the notification and let the caller to catch() the error
  throw error;
};

const GlobalError400Handler = (error, dispatch) => {
  let handled = false;
  // data can be an array, when we POST an array with multiple items
  const itemsErrors = isArray(error.data) ? error.data : [error.data];
  itemsErrors.map((errors) => {
    const generalErrors = get(errors, 'non_field_errors', []);
    map(errorsUpgradeModalMap, (modalId, error) => {
      if (generalErrors.indexOf(error) > -1) {
        handled = true;
        return dispatch(showUpgradeModal(modalId));
      }
    });
  });

  if (error.data === 'TRIAL_EXPIRED') {
    window.location.replace(urls.TRIAL_UPGRADE_URL);
  }

  if (error.data.detail_code === 'FORCE_2FA') {
    window.location.replace(urls.FORCE_2FA);
  }

  if (!handled) {
    throw error;
  }
};

const GlobalError403Handler = (error) => {
  window.location.replace(urls.RESET_URL);
  throw error;
};

const BodyTooLargeErrorHandler = (error, dispatch) => {
  dispatch(
    showNotification(
      gt(
        'These changes are larger than the maximum size of 5MB. Please reduce the document size.'
      ),
      'error'
    )
  );
  throw error;
};

export const globalHandlers = {
  400: GlobalError400Handler,
  403: GlobalError403Handler,
  407: Generic4XXErrorHandler,
  413: BodyTooLargeErrorHandler,
  500: Generic5XXErrorHandler,
  502: Generic5XXErrorHandler,
};
